import angular from 'angular';
import 'ng-file-upload';
import '../alert-message';

import { UploaderComponent } from './uploader.component';

angular
  .module('core.components.uploader', ['core.components.alert-message', 'ngFileUpload'])
  .component('easyshipUploader', UploaderComponent);
